import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';

/**
 * Agenda seznamu obchodních případů — pilotní univerzální ListPage
 * (engine `@/shared/ui/list-page`, šablona `businessCaseListPage.tsx`).
 * `state: listPageViewState` drží aktivní pohled (záložku) v URL paramu `view`
 * (reload/deeplink obnoví uložený pohled; čerstvé otevření začne na „Vše").
 */
export const businessCaseListAgenda = defineAgenda({
  id: 'reservations.business-cases',
  path: 'reservations/business-cases',
  open: {},
  state: listPageViewState,
  title: 'Obchodní případy',
  icon: 'doc',
});
